export const getKillmail = 'getKillmail';
export const updateKillmail = 'updateKillmail';
export const addAlt = 'addAlt';
export const removeAlt = 'removeAlt';
export const updatePayoutData = 'updatePayoutData';
export const updatePayoutDataSplit = 'updatePayoutDataSplit';
export const addSplit = 'addSplit';
export const removeSplit = 'removeSplit';
